import { API } from '../../../modules/api';
import { DATA } from '../../../modules/data'
import { WEIXIN_PAY } from '../../weixin'

export default {
    namespaced: true,
    state: {
		gotProductData: false,
		productList: [],
		reportShowPayCode: false,
		wechatPayCodeValue: '',
		wechatPayParams: {},
    },
    mutations: {},
    actions: {
		getProductList({state}, params) {
			if(state.gotProductData) { return; }
			API.getProductList({
				type: params.type.toString()
			}, function(data) {
				console.log('获取商品列表成功:::::::', data)
				state.gotProductData = true;
				state.productList = DATA.getProductDataByData(data);
			})
		},
		createPayOrder({state}, params) {
			// console.error('createPayOrder------', params)
			API.createPayOrder(params.params, function(data) {
				console.log('下单成功:::::::', data);
				state.wechatPayParams = params.params;
				state.wechatPayCodeValue = data.return;
				state.reportShowPayCode = true;
				if(params && params.sucCb && typeof(params.sucCb) == 'function') {
					params.sucCb();
				}
				// WEIXIN_PAY.createOrder(data.return, function(data) {
                //     console.log('clickPay-----支付成功', data)
                //     if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                //         params.sucCb();
                //     }
                // }, function(data) {
                //     console.error('clickPay-----支付失败', data)
                //     if(params && params.failCb && typeof(params.failCb) == 'function') {
                //         params.failCb();
                //     }
                // })
			})
		},
		resetData({state}) {
			state.productList = [];
		}
    }
}